import React, { useState } from 'react'
import attendenceModals from '../../modals/attendenceModals'
import Actions from './Actions'

const MarkAttendence = (props) => {
    const [loader, setLoader] = useState(false)
    const [message, setMessage] = useState("")

    let type = props.type
    if(!type){
        type = "Present"
    }
    const MESSAGE = `${type} has been marked Sucessfully`

    const mark = async (status) => {
        try{

            setLoader(true)
            const response = await attendenceModals.markAttendence({ status })
            setLoader(false)
            if(response.employee_id){
                setMessage(MESSAGE)
            }
            console.log(response)
        }catch(err){
            console.log(err)
            setLoader(false)
        }
    }

    return (
        <div>
            <Actions
                handle={() => mark(type)}
                title={`Mark ${type}`}
                head={`Mark Your ${type} (Today)`}
                loader={loader}
                message={message}
                messagetype={props.messagetype}
            />
        </div>
    )
}

export default MarkAttendence
